import { render, staticRenderFns } from "./AddPublisher.vue?vue&type=template&id=2f218b74"
import script from "./AddPublisher.vue?vue&type=script&lang=js"
export * from "./AddPublisher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports